const set = require('lodash/fp/set');
const _ = require('lodash/fp/curry').placeholder;

function ItemOrchestrator(itemService, productService, $q) {
  function expandProduct(item) {
    if (!item.productId) {
      return item;
    }

    return productService.get(item.productId, { cache: true }).then(set('product', _, item));
  }

  this.getItemsWithProductsForShipment = function(shipmentId) {
    return itemService.getAll({ order: shipmentId, pagination: { pageSize: 100 } })
      .then(items => $q.all(items.map(expandProduct)));
  };
}

ItemOrchestrator.$inject = ['ogsdk.itemService', 'ogsdk.productService', '$q'];

module.exports = ItemOrchestrator;
